export default __webpack_public_path__ + "static/media/mountain-fog.82a43b26.jpg";